export default __webpack_public_path__ + "dist/media/Mention.dfc40d8c.svg";